export default __webpack_public_path__ + "static/media/08 - ProjectD.csproj (1).70e8235e.png";